export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOI',
  CurrentTierStyling = 'specs.loyalty.CurrentTierStyling',
  SocialMedia = 'specs.loyalty.SocialMediaLiveSite',
  CheckoutMonetaryEarnValue = 'specs.loyalty.CheckoutMonetaryEarnValue',
  Birthday = 'specs.loyalty.BirthdayPointsLiveSite',
  StatusWidget = 'specs.loyalty.StatusWidget',
}
